import { rem } from 'polished'

import Text from '../../Text'
import { css, styled } from '../../theme'
import { colors } from '../../theme/colors'
import { media } from '../../theme/media'

export const Wrapper = styled.label`
  display: inline-flex;
  align-items: center;
  height: ${rem(30)};
  cursor: pointer;
  ${media.onlyMobile`
    width: 100%;
    &:not(:last-child) {
      margin-bottom: ${rem(20)};
  }
  `}
  &:not(:last-child) {
    margin-right: ${rem(20)};
  }
`

export const Label = styled(Text).attrs({})`
  display: inline-flex;
  flex-grow: 1;
  height: ${rem(26)};
  margin-left: ${rem(10)};
`

export const RadioDot = styled.span.attrs({})<{ checked: boolean }>`
  display: inline-flex;
  position: relative;
  width: 30px;
  height: 30px;
  flex-basis: 30px;
  align-self: center;
  flex-shrink: 0;

  border: 2px solid ${colors.grayDark};
  border-radius: 50%;

  z-index: 2;
  ${Wrapper}:hover:not([checked]) & {
    border: 2px solid ${colors.primaryDark};
  }

  ${p =>
    p.checked &&
    css`
      &:before {
        content: '';
        position: absolute;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 2px solid ${colors.primaryDark};
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    `}
`

export const RadioView = styled.input`
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;

  &:focus {
    outline: none;
  }
`
